export default __webpack_public_path__ + "static/media/moneyCash.ded1ec9c.svg";